export default "__VITE_ASSET__c6P$pcxD__"